import callAPiBase from './base';

const benefitsApi = {
  list: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/benefitList',
      method: 'GET',
      useToken: true,
      title: 'Benefits - Get List',
      params,
    }),
  listLines: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/benefitListLines',
      method: 'GET',
      useToken: true,
      title: 'Benefits - List Lines',
      params,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/benefitList',
      method: 'GET',
      useToken: true,
      title: 'Benefit - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/benefitCreate',
      method: 'POST',
      useToken: true,
      title: 'Benefit - Create',
      data,
    }),
  attach: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/benefitAttach',
      method: 'POST',
      useToken: true,
      title: 'Benefit - Attach',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/benefitUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Benefit - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/benefitDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Benefit - Delete',
      params,
    }),
};

export default benefitsApi;
export { benefitsApi };
